import { FC, KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@mui/material';

import { appShellInertDomProps } from '@/hooks/useInertBackground';

export const MAIN_CONTENT_ID = 'main-content';

export const SkipToMainContentLink: FC = () => {
  const { t } = useTranslation();

  const handleKeyDown = (event: KeyboardEvent<HTMLAnchorElement>) => {
    if (event.key === ' ' || event.key === 'Spacebar') {
      event.stopPropagation();
      event.preventDefault();
      event.currentTarget.click();
    }
  };

  return (
    <Link
      id="skip-content"
      {...appShellInertDomProps}
      href={`#${MAIN_CONTENT_ID}`}
      sx={(theme) => ({
        position: 'absolute',
        left: '-9999px',
        zIndex: 1501,
        padding: '1em',
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        opacity: 0,
        '&:focus': {
          left: '50%',
          transform: 'translateX(-50%)',
          opacity: 1,
        },
      })}
      onKeyDown={handleKeyDown}
    >
      {t('skipToMainContent')}
    </Link>
  );
};
